import { apiClient } from './client';
import type { Activity } from '../types/api.types';

export interface SprayMaterialInput {
  productId?: string;
  name:       string;
  quantity:   number;
  unit:       string;
  unitCost?:  number;
  totalCost?: number;
}

export interface SprayDataInput {
  cargas?:      number;
  velocidad?:   number;
  litrosAgua?:  number;
  horaEntrada?: string;
  horaSalida?:  string;
  operador?:    string;
  equipo?:      string;
}

export interface CreateSprayInput {
  /** Zona o subzona aplicada (opcional) */
  moduleId?:           string;
  occurredAt:          string;
  materials:           SprayMaterialInput[];
  batchId?:            string;
  laborCost?:          number;
  machineryCost?:      number;
  productId:           string;
  activeIngredient?:   string;
  crop:                string;
  market:              'US' | 'MX' | 'CA';
  doseMgPerKg?:        number;
  plannedHarvestDate?: string;
  sprayData?:          SprayDataInput;
}

export const createSpray = async (loteId: string, input: CreateSprayInput): Promise<Activity & { budgetWarning?: string }> =>
  (await apiClient.post(`/api/lotes/${loteId}/spray`, input)).data;
